import { saveAs as importedSaveAs } from "file-saver";

import { otherAPIHeaders, testAPIHeaders } from "../shared-resources/dumpData";

export function createUserAPI(body) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${process.env.KIRKLAND_APP_API_URL}/user-setting/users`,
        {
          method: "POST",
          headers: testAPIHeaders,
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const res = await response.json();
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function updateUserAPI(body) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${process.env.KIRKLAND_APP_API_URL}/user-setting/users`,
        {
          method: "PUT",
          headers: testAPIHeaders,
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const res = await response.json();
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function getUserAPI() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${process.env.KIRKLAND_APP_API_URL}/user-setting/users`,
        {
          method: "GET",
          headers: testAPIHeaders,
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const res = await response.json();
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
}
